/**
 * Slovenské banky v integráciách - rovnaký zoznam ako backend
 * (`apps/reservations/banks.py`). Fio má API, ostatné import výpisu z účtu.
 *
 * Ikonka je farebná značka s iniciálami, nie logo banky: logá sú ochranné
 * známky a nemáme ich od bánk. Farby približne podľa ich vizuálu.
 */
import { cn } from '@/lib/utils'

export interface Bank {
  code: string
  name: string
  short: string
  color: string
}

export const FIO: Bank = { code: 'fio', name: 'Fio banka', short: 'Fio', color: '#0f8a3c' }

export const STATEMENT_BANKS: Bank[] = [
  { code: 'tatra', name: 'Tatra banka', short: 'TB', color: '#1d1d1b' },
  { code: 'slsp', name: 'Slovenská sporiteľňa', short: 'SLSP', color: '#2870ed' },
  { code: 'vub', name: 'VÚB banka', short: 'VÚB', color: '#00529b' },
  { code: 'csob', name: 'ČSOB', short: 'ČSOB', color: '#0a2a5c' },
  { code: 'prima', name: 'Prima banka', short: 'P', color: '#e5501e' },
  { code: 'unicredit', name: 'UniCredit Bank', short: 'UC', color: '#e2001a' },
  { code: '365', name: '365.bank', short: '365', color: '#00a0b0' },
  { code: 'mbank', name: 'mBank', short: 'm', color: '#a3001e' },
]

export const ALL_BANKS: Bank[] = [FIO, ...STATEMENT_BANKS]

export function bankByCode(code: string) {
  return ALL_BANKS.find((bank) => bank.code === code)
}

/** „Tatra banka SK“ - integrácie sú pre slovenské účty. */
export function bankLabel(bank: Bank) {
  return `${bank.name} SK`
}

export function BankIcon({ bank, size = 28 }: { bank: Bank; size?: number }) {
  const long = bank.short.length > 3
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-md font-bold leading-none text-white',
        long ? 'tracking-tight' : '',
      )}
      style={{
        width: size,
        height: size,
        background: bank.color,
        fontSize: size * (bank.short.length <= 2 ? 0.42 : bank.short.length === 3 ? 0.34 : 0.27),
      }}
    >
      {bank.short}
    </span>
  )
}
